import {
  GET_MERCHANTS,
  GET_MERCHANTS_FAIL,
  GET_MERCHANTS_SUCCESS,
  CLEAR_MERCHANTS,
  ADD_NEW_MERCHANT,
  ADD_NEW_MERCHANT_SUCCESS,
  ADD_NEW_MERCHANT_FAIL,
  GET_MERCHANT_DETAIL,
  GET_MERCHANT_DETAIL_SUCCESS,
  GET_MERCHANT_DETAIL_FAIL,
  CLEAR_MERCHANT_DETAIL,
  GET_MERCHANT_COMMUNICATIONS,
  GET_MERCHANT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_COMMUNICATIONS_FAIL,
  CLEAR_MERCHANT_COMMUNICATIONS,
  MANAGE_MERCHANT_COMMUNICATION,
  MANAGE_MERCHANT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_COMMUNICATION_FAIL,
  GET_MERCHANT_CONTACTS,
  GET_MERCHANT_CONTACTS_SUCCESS,
  GET_MERCHANT_CONTACTS_FAIL,
  CLEAR_MERCHANT_CONTACTS,
  MANAGE_MERCHANT_CONTACT,
  MANAGE_MERCHANT_CONTACT_SUCCESS,
  MANAGE_MERCHANT_CONTACT_FAIL,
  GET_MERCHANT_CONTACT_COMMUNICATIONS,
  GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL,
  GET_MERCHANT_BANKING_DETAIL,
  GET_MERCHANT_BANKING_DETAIL_SUCCESS,
  GET_MERCHANT_BANKING_DETAIL_FAIL,
  CLEAR_MERCHANT_BANKING_DETAIL,
  ADD_NEW_MERCHANT_BANKING,
  ADD_NEW_MERCHANT_BANKING_SUCCESS,
  ADD_NEW_MERCHANT_BANKING_FAIL,
  SET_CONTACT_CREATION_STATE,
  CLEAR_CONTACT_CREATION_STATE,
  DELETE_MERCHANT,
  DELETE_MERCHANT_SUCCESS,
  DELETE_MERCHANT_FAIL,
  MANAGE_MERCHANT_BANKING,
  MANAGE_MERCHANT_BANKING_SUCCESS,
  MANAGE_MERCHANT_BANKING_FAIL,
  TOGGLE_MERCHANT_BANKING_DEFAULT,
  TOGGLE_MERCHANT_BANKING_DEFAULT_SUCCESS,
  TOGGLE_MERCHANT_BANKING_DEFAULT_FAIL,
  CHECK_MERCHANT_BANKING_STATUS,
  CHECK_MERCHANT_BANKING_STATUS_SUCCESS,
  CHECK_MERCHANT_BANKING_STATUS_FAIL,
  GET_MERCHANT_IMAGES,
  GET_MERCHANT_IMAGES_SUCCESS,
  GET_MERCHANT_IMAGES_FAIL,
  CLEAR_MERCHANT_IMAGES,
  MANAGE_MERCHANT_IMAGE,
  MANAGE_MERCHANT_IMAGE_SUCCESS,
  MANAGE_MERCHANT_IMAGE_FAIL,
  GET_MERCHANT_TIMINGS,
  GET_MERCHANT_TIMINGS_SUCCESS,
  GET_MERCHANT_TIMINGS_FAIL,
  CLEAR_MERCHANT_TIMINGS,
  MANAGE_MERCHANT_TIMING,
  MANAGE_MERCHANT_TIMING_SUCCESS,
  MANAGE_MERCHANT_TIMING_FAIL,
  GET_MERCHANT_ATTRIBUTES,
  GET_MERCHANT_ATTRIBUTES_SUCCESS,
  GET_MERCHANT_ATTRIBUTES_FAIL,
  CLEAR_MERCHANT_ATTRIBUTES,
  MANAGE_MERCHANT_ATTRIBUTE,
  MANAGE_MERCHANT_ATTRIBUTE_SUCCESS,
  MANAGE_MERCHANT_ATTRIBUTE_FAIL,
  ADD_ATTRIBUTE_TO_FORM,
  UPDATE_ATTRIBUTE_IN_FORM,
  REMOVE_ATTRIBUTE_FROM_FORM,
  CLEAR_ATTRIBUTE_FORM,
  GET_MERCHANT_TAGS,
  GET_MERCHANT_TAGS_SUCCESS,
  GET_MERCHANT_TAGS_FAIL,
  CLEAR_MERCHANT_TAGS,
  MANAGE_MERCHANT_TAG,
  MANAGE_MERCHANT_TAG_SUCCESS,
  MANAGE_MERCHANT_TAG_FAIL,
  GET_TAG_DEFINITIONS,
  GET_TAG_DEFINITIONS_SUCCESS,
  GET_TAG_DEFINITIONS_FAIL,
  CLEAR_TAG_DEFINITIONS,
  GET_MERCHANT_VARIABLES,
  GET_MERCHANT_VARIABLES_SUCCESS,
  GET_MERCHANT_VARIABLES_FAIL,
  CREATE_MERCHANT_VARIABLES,
  CREATE_MERCHANT_VARIABLES_SUCCESS,
  CREATE_MERCHANT_VARIABLES_FAIL,
  UPDATE_MERCHANT_VARIABLES,
  UPDATE_MERCHANT_VARIABLES_SUCCESS,
  UPDATE_MERCHANT_VARIABLES_FAIL,
  CLEAR_MERCHANT_VARIABLES,
  GET_RECONCILIATION_FREQUENCIES,
  GET_RECONCILIATION_FREQUENCIES_SUCCESS,
  GET_RECONCILIATION_FREQUENCIES_FAIL,
  CLEAR_RECONCILIATION_FREQUENCIES,
  ADD_TIMING_TO_FORM,
  UPDATE_TIMING_IN_FORM,
  REMOVE_TIMING_FROM_FORM,
  CLEAR_TIMING_FORM,
  CLEAR_TIMING_CREATION_SUCCESS,
  CLEAR_ATTRIBUTE_CREATION_SUCCESS,
  REORDER_MERCHANT_IMAGES,
  REORDER_MERCHANT_IMAGES_SUCCESS,
  REORDER_MERCHANT_IMAGES_FAIL,
  SET_LOCAL_IMAGES_ORDER,
  RESET_LOCAL_IMAGES_ORDER,
  GET_MERCHANT_PINS,
  GET_MERCHANT_PINS_SUCCESS,
  GET_MERCHANT_PINS_FAIL,
  CLEAR_MERCHANT_PINS,
  SHOW_MERCHANT_PINS,
  SHOW_MERCHANT_PINS_SUCCESS,
  SHOW_MERCHANT_PINS_FAIL,
  UPDATE_MERCHANT_PINS,
  UPDATE_MERCHANT_PINS_SUCCESS,
  UPDATE_MERCHANT_PINS_FAIL,
} from "./actionTypes"

export const getMerchants = (options, history) => ({
  type: GET_MERCHANTS,
  payload: { options, history },
})

export const getMerchantsSuccess = merchants => ({
  type: GET_MERCHANTS_SUCCESS,
  payload: merchants,
})

export const getMerchantsFail = error => ({
  type: GET_MERCHANTS_FAIL,
  payload: error,
})

export const clearMerchants = () => ({
  type: CLEAR_MERCHANTS,
})

// add new merchant
export const addNewMerchant = (data, options, history) => ({
  type: ADD_NEW_MERCHANT,
  payload: { data, options, history },
})

export const addNewMerchantSuccess = merchant => ({
  type: ADD_NEW_MERCHANT_SUCCESS,
  payload: merchant,
})

export const addNewMerchantFail = error => ({
  type: ADD_NEW_MERCHANT_FAIL,
  payload: error,
})

export const getMerchantDetail = (options, history) => ({
  type: GET_MERCHANT_DETAIL,
  payload: { options, history },
})

export const getMerchantDetailSuccess = merchant => ({
  type: GET_MERCHANT_DETAIL_SUCCESS,
  payload: merchant,
})

export const getMerchantDetailFail = error => ({
  type: GET_MERCHANT_DETAIL_FAIL,
  payload: error,
})

export const clearMerchantDetail = () => ({
  type: CLEAR_MERCHANT_DETAIL,
})

// Merchant Communications
export const getMerchantCommunications = (options, history) => ({
  type: GET_MERCHANT_COMMUNICATIONS,
  payload: { options, history },
})

export const getMerchantCommunicationsSuccess = communications => ({
  type: GET_MERCHANT_COMMUNICATIONS_SUCCESS,
  payload: communications,
})

export const getMerchantCommunicationsFail = error => ({
  type: GET_MERCHANT_COMMUNICATIONS_FAIL,
  payload: error,
})

export const clearMerchantCommunications = () => ({
  type: CLEAR_MERCHANT_COMMUNICATIONS,
})

export const manageMerchantCommunication = (data, options, history) => ({
  type: MANAGE_MERCHANT_COMMUNICATION,
  payload: { data, options, history },
})

export const manageMerchantCommunicationSuccess = communication => ({
  type: MANAGE_MERCHANT_COMMUNICATION_SUCCESS,
  payload: communication,
})

export const manageMerchantCommunicationFail = error => ({
  type: MANAGE_MERCHANT_COMMUNICATION_FAIL,
  payload: error,
})

// Merchant Contacts
export const getMerchantContacts = (options, history) => ({
  type: GET_MERCHANT_CONTACTS,
  payload: { options, history },
})

export const getMerchantContactsSuccess = contacts => ({
  type: GET_MERCHANT_CONTACTS_SUCCESS,
  payload: contacts,
})

export const getMerchantContactsFail = error => ({
  type: GET_MERCHANT_CONTACTS_FAIL,
  payload: error,
})

export const clearMerchantContacts = () => ({
  type: CLEAR_MERCHANT_CONTACTS,
})

export const manageMerchantContact = (data, options, history) => ({
  type: MANAGE_MERCHANT_CONTACT,
  payload: { data, options, history },
})

export const manageMerchantContactSuccess = contact => ({
  type: MANAGE_MERCHANT_CONTACT_SUCCESS,
  payload: contact,
})

export const manageMerchantContactFail = error => ({
  type: MANAGE_MERCHANT_CONTACT_FAIL,
  payload: error,
})

// Merchant Contact Communications
export const getMerchantContactCommunications = (options, history) => ({
  type: GET_MERCHANT_CONTACT_COMMUNICATIONS,
  payload: { options, history },
})

export const getMerchantContactCommunicationsSuccess = communications => ({
  type: GET_MERCHANT_CONTACT_COMMUNICATIONS_SUCCESS,
  payload: communications,
})

export const getMerchantContactCommunicationsFail = error => ({
  type: GET_MERCHANT_CONTACT_COMMUNICATIONS_FAIL,
  payload: error,
})

export const manageMerchantContactCommunication = (data, options, history) => ({
  type: MANAGE_MERCHANT_CONTACT_COMMUNICATION,
  payload: { data, options, history },
})

export const manageMerchantContactCommunicationSuccess = communication => ({
  type: MANAGE_MERCHANT_CONTACT_COMMUNICATION_SUCCESS,
  payload: communication,
})

export const manageMerchantContactCommunicationFail = error => ({
  type: MANAGE_MERCHANT_CONTACT_COMMUNICATION_FAIL,
  payload: error,
})

// Merchant Banking
export const getMerchantBankingDetail = (options, history) => ({
  type: GET_MERCHANT_BANKING_DETAIL,
  payload: { options, history },
})

export const getMerchantBankingDetailSuccess = banking => ({
  type: GET_MERCHANT_BANKING_DETAIL_SUCCESS,
  payload: banking,
})

export const getMerchantBankingDetailFail = error => ({
  type: GET_MERCHANT_BANKING_DETAIL_FAIL,
  payload: error,
})

export const clearMerchantBankingDetail = () => ({
  type: CLEAR_MERCHANT_BANKING_DETAIL,
})

export const addNewMerchantBanking = (data, options, history) => ({
  type: ADD_NEW_MERCHANT_BANKING,
  payload: { data, options, history },
})

export const addNewMerchantBankingSuccess = banking => ({
  type: ADD_NEW_MERCHANT_BANKING_SUCCESS,
  payload: banking,
})

export const addNewMerchantBankingFail = error => ({
  type: ADD_NEW_MERCHANT_BANKING_FAIL,
  payload: error,
})

// Manage Merchant Banking Actions
export const manageMerchantBanking = (data, options, history) => ({
  type: MANAGE_MERCHANT_BANKING,
  payload: { data, options, history },
})

export const manageMerchantBankingSuccess = banking => ({
  type: MANAGE_MERCHANT_BANKING_SUCCESS,
  payload: banking,
})

export const manageMerchantBankingFail = error => ({
  type: MANAGE_MERCHANT_BANKING_FAIL,
  payload: error,
})

// Toggle Merchant Banking Default
export const toggleMerchantBankingDefault = (data, options, history) => ({
  type: TOGGLE_MERCHANT_BANKING_DEFAULT,
  payload: { data, options, history },
})

export const toggleMerchantBankingDefaultSuccess = banking => ({
  type: TOGGLE_MERCHANT_BANKING_DEFAULT_SUCCESS,
  payload: banking,
})

export const toggleMerchantBankingDefaultFail = error => ({
  type: TOGGLE_MERCHANT_BANKING_DEFAULT_FAIL,
  payload: error,
})

// Contact Creation State Actions
export const setMerchantContactCreationState = (state) => ({
  type: SET_CONTACT_CREATION_STATE,
  payload: state,
})

export const clearMerchantContactCreationState = () => ({
  type: CLEAR_CONTACT_CREATION_STATE,
})

// Delete Merchant Actions
export const deleteMerchant = (data, options, history) => ({
  type: DELETE_MERCHANT,
  payload: { data, options, history },
})

export const deleteMerchantSuccess = response => ({
  type: DELETE_MERCHANT_SUCCESS,
  payload: response,
})

export const deleteMerchantFail = error => ({
  type: DELETE_MERCHANT_FAIL,
  payload: error,
})

// Get Merchant Images
export const getMerchantImages = (options, history) => ({
  type: GET_MERCHANT_IMAGES,
  payload: { options, history },
})

export const getMerchantImagesSuccess = images => ({
  type: GET_MERCHANT_IMAGES_SUCCESS,
  payload: images,
})

export const getMerchantImagesFail = error => ({
  type: GET_MERCHANT_IMAGES_FAIL,
  payload: error,
})

export const clearMerchantImages = () => ({
  type: CLEAR_MERCHANT_IMAGES,
})

// Manage Merchant Image
export const manageMerchantImage = (data, options, history) => ({
  type: MANAGE_MERCHANT_IMAGE,
  payload: { data, options, history },
})

export const manageMerchantImageSuccess = response => ({
  type: MANAGE_MERCHANT_IMAGE_SUCCESS,
  payload: response,
})

export const manageMerchantImageFail = error => ({
  type: MANAGE_MERCHANT_IMAGE_FAIL,
  payload: error,
})

// Reorder Merchant Images
export const reorderMerchantImages = (data, options, history) => ({
  type: REORDER_MERCHANT_IMAGES,
  payload: { data, options, history },
})

export const reorderMerchantImagesSuccess = response => ({
  type: REORDER_MERCHANT_IMAGES_SUCCESS,
  payload: response,
})

export const reorderMerchantImagesFail = error => ({
  type: REORDER_MERCHANT_IMAGES_FAIL,
  payload: error,
})

// Local state management for image ordering
export const setLocalImagesOrder = images => ({
  type: SET_LOCAL_IMAGES_ORDER,
  payload: images,
})

export const resetLocalImagesOrder = () => ({
  type: RESET_LOCAL_IMAGES_ORDER,
})

// Merchant Timings Actions
export const getMerchantTimings = (options, history) => ({
  type: GET_MERCHANT_TIMINGS,
  payload: { options, history },
})

export const getMerchantTimingsSuccess = timings => ({
  type: GET_MERCHANT_TIMINGS_SUCCESS,
  payload: timings,
})

export const getMerchantTimingsFail = error => ({
  type: GET_MERCHANT_TIMINGS_FAIL,
  payload: error,
})

export const clearMerchantTimings = () => ({
  type: CLEAR_MERCHANT_TIMINGS,
})

export const manageMerchantTiming = (data, options, history) => ({
  type: MANAGE_MERCHANT_TIMING,
  payload: { data, options, history },
})

export const manageMerchantTimingSuccess = timing => ({
  type: MANAGE_MERCHANT_TIMING_SUCCESS,
  payload: timing,
})

export const manageMerchantTimingFail = error => ({
  type: MANAGE_MERCHANT_TIMING_FAIL,
  payload: error,
})

// Timing form state management actions
export const addTimingToForm = (timing) => ({
  type: ADD_TIMING_TO_FORM,
  payload: timing,
})

export const updateTimingInForm = (index, timing) => ({
  type: UPDATE_TIMING_IN_FORM,
  payload: { index, timing },
})

export const removeTimingFromForm = (index) => ({
  type: REMOVE_TIMING_FROM_FORM,
  payload: index,
})

export const clearTimingForm = () => ({
  type: CLEAR_TIMING_FORM,
})
// Get Merchant Attributes
export const getMerchantAttributes = (options, history) => ({
  type: GET_MERCHANT_ATTRIBUTES,
  payload: { options, history },
})

export const getMerchantAttributesSuccess = attributes => ({
  type: GET_MERCHANT_ATTRIBUTES_SUCCESS,
  payload: attributes,
})

export const getMerchantAttributesFail = error => ({
  type: GET_MERCHANT_ATTRIBUTES_FAIL,
  payload: error,
})

export const clearMerchantAttributes = () => ({
  type: CLEAR_MERCHANT_ATTRIBUTES,
})

// Manage Merchant Attribute
export const manageMerchantAttribute = (data, options, history) => ({
  type: MANAGE_MERCHANT_ATTRIBUTE,
  payload: { data, options, history },
})

export const manageMerchantAttributeSuccess = response => ({
  type: MANAGE_MERCHANT_ATTRIBUTE_SUCCESS,
  payload: response,
})

export const manageMerchantAttributeFail = error => ({
  type: MANAGE_MERCHANT_ATTRIBUTE_FAIL,
  payload: error,
})

// Form state management actions
export const addAttributeToForm = (attribute) => ({
  type: ADD_ATTRIBUTE_TO_FORM,
  payload: attribute,
})

export const updateAttributeInForm = (index, attribute) => ({
  type: UPDATE_ATTRIBUTE_IN_FORM,
  payload: { index, attribute },
})

export const removeAttributeFromForm = (index) => ({
  type: REMOVE_ATTRIBUTE_FROM_FORM,
  payload: index,
})

export const clearAttributeForm = () => ({
  type: CLEAR_ATTRIBUTE_FORM,
})

// Get Merchant Tags
export const getMerchantTags = (options, history) => ({
  type: GET_MERCHANT_TAGS,
  payload: { options, history },
})

export const getMerchantTagsSuccess = tags => ({
  type: GET_MERCHANT_TAGS_SUCCESS,
  payload: tags,
})

export const getMerchantTagsFail = error => ({
  type: GET_MERCHANT_TAGS_FAIL,
  payload: error,
})

export const clearMerchantTags = () => ({
  type: CLEAR_MERCHANT_TAGS,
})

// Manage Merchant Tag
export const manageMerchantTag = (data, options, history) => ({
  type: MANAGE_MERCHANT_TAG,
  payload: { data, options, history },
})

export const manageMerchantTagSuccess = response => ({
  type: MANAGE_MERCHANT_TAG_SUCCESS,
  payload: response,
})

export const manageMerchantTagFail = error => ({
  type: MANAGE_MERCHANT_TAG_FAIL,
  payload: error,
})

// Get Tag Definitions
export const getTagDefinitions = (options, history) => ({
  type: GET_TAG_DEFINITIONS,
  payload: { options, history },
})

export const getTagDefinitionsSuccess = definitions => ({
  type: GET_TAG_DEFINITIONS_SUCCESS,
  payload: definitions,
})

export const getTagDefinitionsFail = error => ({
  type: GET_TAG_DEFINITIONS_FAIL,
  payload: error,
})

export const clearTagDefinitions = () => ({
  type: CLEAR_TAG_DEFINITIONS,
})
// Create Merchant Variables
export const createMerchantVariables = (data, options, history) => ({
  type: CREATE_MERCHANT_VARIABLES,
  payload: { data, options, history },
})

export const createMerchantVariablesSuccess = response => ({
  type: CREATE_MERCHANT_VARIABLES_SUCCESS,
  payload: response,
})

export const createMerchantVariablesFail = error => ({
  type: CREATE_MERCHANT_VARIABLES_FAIL,
  payload: error,
})

// Update Merchant Variables
export const updateMerchantVariables = (data, options, history) => ({
  type: UPDATE_MERCHANT_VARIABLES,
  payload: { data, options, history },
})

export const updateMerchantVariablesSuccess = response => ({
  type: UPDATE_MERCHANT_VARIABLES_SUCCESS,
  payload: response,
})

export const updateMerchantVariablesFail = error => ({
  type: UPDATE_MERCHANT_VARIABLES_FAIL,
  payload: error,
})

export const clearMerchantVariables = () => ({
  type: CLEAR_MERCHANT_VARIABLES,
})

// Get Merchant Variables
export const getMerchantVariables = (options, history) => ({
  type: GET_MERCHANT_VARIABLES,
  payload: { options, history },
})

export const getMerchantVariablesSuccess = response => ({
  type: GET_MERCHANT_VARIABLES_SUCCESS,
  payload: response,
})

export const getMerchantVariablesFail = error => ({
  type: GET_MERCHANT_VARIABLES_FAIL,
  payload: error,
})

// Get Reconciliation Frequencies
export const getReconciliationFrequencies = () => ({
  type: GET_RECONCILIATION_FREQUENCIES,
})

export const getReconciliationFrequenciesSuccess = response => ({
  type: GET_RECONCILIATION_FREQUENCIES_SUCCESS,
  payload: response,
})

export const getReconciliationFrequenciesFail = error => ({
  type: GET_RECONCILIATION_FREQUENCIES_FAIL,
  payload: error,
})

export const clearReconciliationFrequencies = () => ({
  type: CLEAR_RECONCILIATION_FREQUENCIES,
})

export const clearTimingCreationSuccess = () => ({
  type: CLEAR_TIMING_CREATION_SUCCESS,
})

export const clearAttributeCreationSuccess = () => ({
  type: CLEAR_ATTRIBUTE_CREATION_SUCCESS,
})

// Merchant PINs Actions
export const getMerchantPins = (options, history) => ({
  type: GET_MERCHANT_PINS,
  payload: { options, history },
})

export const getMerchantPinsSuccess = pins => ({
  type: GET_MERCHANT_PINS_SUCCESS,
  payload: pins,
})

export const getMerchantPinsFail = error => ({
  type: GET_MERCHANT_PINS_FAIL,
  payload: error,
})

export const clearMerchantPins = () => ({
  type: CLEAR_MERCHANT_PINS,
})

export const showMerchantPins = (options, history) => ({
  type: SHOW_MERCHANT_PINS,
  payload: { options, history },
})

export const showMerchantPinsSuccess = pins => ({
  type: SHOW_MERCHANT_PINS_SUCCESS,
  payload: pins,
})

export const showMerchantPinsFail = error => ({
  type: SHOW_MERCHANT_PINS_FAIL,
  payload: error,
})

export const updateMerchantPins = (data, options, history) => ({
  type: UPDATE_MERCHANT_PINS,
  payload: { data, options, history },
})

export const updateMerchantPinsSuccess = response => ({
  type: UPDATE_MERCHANT_PINS_SUCCESS,
  payload: response,
})

export const updateMerchantPinsFail = error => ({
  type: UPDATE_MERCHANT_PINS_FAIL,
  payload: error,
})

// Check Merchant Banking Status
export const checkMerchantBankingStatus = (destinationID) => ({
  type: CHECK_MERCHANT_BANKING_STATUS,
  payload: { destinationID },
})

export const checkMerchantBankingStatusSuccess = (destinationID, status) => ({
  type: CHECK_MERCHANT_BANKING_STATUS_SUCCESS,
  payload: { destinationID, status },
})

export const checkMerchantBankingStatusFail = error => ({
  type: CHECK_MERCHANT_BANKING_STATUS_FAIL,
  payload: error,
})